import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios, { getApiUrl } from "@/lib/api";

const API = `${getApiUrl()}/api`;

const SubscriptionContext = createContext({
  paywallEnabled: false,
  isPro: true,
  subscription: null,
  plan: null,
  proFeatures: [],
  loading: true,
  refresh: () => {},
  requirePro: () => true,
});

export function SubscriptionProvider({ children }) {
  const [state, setState] = useState({
    paywallEnabled: false,
    isPro: true,
    subscription: null,
    plans: {},
    proFeatures: [],
    loading: true,
  });

  const fetchStatus = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/subscription/status`);
      setState({
        paywallEnabled: res.data.paywallEnabled,
        isPro: res.data.isPro,
        subscription: res.data.subscription,
        plans: res.data.plans || {},
        proFeatures: res.data.proFeatures || [],
        loading: false,
      });
    } catch {
      // If not logged in or API fails, default to unlocked
      setState(prev => ({ ...prev, loading: false }));
    }
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  const requirePro = useCallback((feature) => {
    if (!state.paywallEnabled) return true;
    if (state.isPro) return true;
    return false;
  }, [state.paywallEnabled, state.isPro]);

  return (
    <SubscriptionContext.Provider value={{ ...state, refresh: fetchStatus, requirePro }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}

export default SubscriptionContext;
